import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubLandingRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-landing',
	path: '/jira/servicedesk/projects/:projectKey/knowledge',
	exact: true,
};
